// import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let router = new VueRouter({
	// mode: 'history',
	// base: process.env.BASE_API,
	routes: [
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/home',
			component: r => require.ensure([], () => r(require('@/views/home/home')), 'home')
		},
		{
			path: '/activityList/:page',
			component: r => require.ensure([], () => r(require('@/views/activity/activityList')), 'activityList')
		},
		{
			path: '/activityDetail',
			component: r => require.ensure([], () => r(require('@/views/activity/activityDetail')), 'activityDetail')
		},
		{
			path: '/modelCoursesList/:page',
			component: r => require.ensure([], () => r(require('@/views/modelCourses/modelCoursesList')), 'modelCoursesList')
		},
		{
			path: '/modelCoursesDetail',
			component: r => require.ensure([], () => r(require('@/views/modelCourses/modelCoursesDetail')), 'modelCoursesDetail')
		},
		{
			path: '/resourcesList/:page',
			component: r => require.ensure([], () => r(require('@/views/resources/resourcesList')), 'resourcesList')
		},
		{
			path: '/resourcesDetail',
			component: r => require.ensure([], () => r(require('@/views/resources/resourcesDetail')), 'resourcesDetail')
		},
		{
			path: '/newsList/:page',
			component: r => require.ensure([], () => r(require('@/views/news/newsList')), 'newsList')
		},
		{
			path: '/newsDetail',
			component: r => require.ensure([], () => r(require('@/views/news/newsDetail')), 'newsDetail')
		},
		{
			path: '/teacherList/:page',
			component: r => require.ensure([], () => r(require('@/views/teacher/teacherList')), 'teacherList')
		},
		{
			path: '/teacherDetail',
			component: r => require.ensure([], () => r(require('@/views/teacher/teacherDetail')), 'teacherDetail')
		},
		{
			path: '/trainList/:page',
			component: r => require.ensure([], () => r(require('@/views/train/trainList')), 'trainList')
		},
		{
			path: '/trainDetail',
			component: r => require.ensure([], () => r(require('@/views/train/trainDetail')), 'trainDetail')
		},
		{
			path: '/search',
			component: r => require.ensure([], () => r(require('@/views/search')), 'search')
		},
		{
			path: '/login',
			component: r => require.ensure([], () => r(require('@/views/login')), 'login')
		}

	]
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js